export var cilentHeaderAccCodeMapper = function (data) {
    var result = {};
    if (data) {
        result.acName = data.acname;
        result.clientTire = data.clienT_TIER;
        result.acType = data.actype;
        result.userName = data.userName;
        result.acCode = data.acCode;
        result.codes = data.codes.map(function (code) {
            return {
                acCode: code.acCode,
            };
        });
    }
    return result;
};
